module.exports = __webpack_public_path__ + "static/media/password-cover.490880b3.svg";